import { fetchAuthSession, getCurrentUser } from 'aws-amplify/auth'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import React, { useEffect, useState } from 'react'
import paths from 'constants/paths'

const PublicRoute = () => {
  const { search } = useLocation()
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  // Amplify appends 'code' + 'state' to the redirect URL during the OAuth PKCE flow.
  // If present, this is an SSO callback — skip the auth check and let Login.jsx
  // handle it via its Hub.listen so handleFederatedSignInRedirect can populate Redux.
  const isSSOCallback = new URLSearchParams(search).has('code')

  useEffect(() => {
    if (isSSOCallback) {
      setIsLoaded(true)

      return
    }

    getCurrentUser()
      .then(() => fetchAuthSession())
      .then(session => {
        if (session?.tokens?.idToken) {
          setIsAuthenticated(true)
        }
        setIsLoaded(true)
      })
      .catch(() => {
        setIsLoaded(true)
      })
  }, [isSSOCallback])

  if (!isLoaded) return null

  return isAuthenticated ? <Navigate to={paths.overview} /> : <Outlet />
}

export default PublicRoute
